/**
 * Minimal HTML sanitiser for rendering user-supplied HTML in dangerouslySetInnerHTML.
 * Strips <script> blocks and inline event handlers (on*=) to prevent XSS.
 *
 * NOTE: For production-grade sanitisation, replace this with DOMPurify if it is
 * added as a dependency. This implementation covers the primary injection vectors
 * without introducing a new package.
 *
 * Pattern reference: src/utils/utils.ts (utility function style).
 */

/**
 * Strips <script>...</script> blocks and inline event handler attributes (on*="...")
 * from an HTML string. Returns the sanitised string.
 */
export function sanitizeHtml(html: string): string {
    if (!html) return '';
    return (
        html
            // Remove <script ...>...</script> blocks (case-insensitive, across newlines)
            .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '')
            // Remove inline event handlers: onXxx="..." or onXxx='...'
            .replace(/\bon\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    );
}
